import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getStocksURL } from '../utils/api';

const useGetStocks = ({ 
        page = 1,
        limit = 3000,
        productId,
        withStocks = undefined,
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingStocks, setGettingStocks ] = useState(false);
    const [ stocks, setStocks ] = useState([]);
    const [ totalStocks, setTotalStocks ] = useState(0);
    const [ gettingStocksReqSuccess, setGettingStocksReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingStocks) {
            axios.get(getStocksURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    productId,
                    page,
                    limit,
                    withStocks,
                }
            }).then(result => {
                setGettingStocks(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    if (result.data.total) {
                        setTotalStocks(result.data.total);
                    }
                    setGettingStocksReqSuccess(true);
                    setStocks(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingStocksReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingStocksReqSuccess(false);
                setGettingStocks(false);
            });
        }
    }, [gettingStocks]);

    return { stocks, totalStocks, gettingStocks, setGettingStocks, gettingStocksReqSuccess };
}

export default useGetStocks;